import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { PublicLayout, Loading } from "@/components/PublicLayout";

import Landing from "@/pages/Landing";

const SubmitQuestion = lazy(() => import("@/pages/SubmitQuestion"));
const StatusPage = lazy(() => import("@/pages/StatusPage"));
const Gallery = lazy(() => import("@/pages/Gallery"));
const Methodology = lazy(() => import("@/pages/Methodology"));
const Results = lazy(() => import("@/pages/Results"));
const Watch = lazy(() => import("@/pages/Watch"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const Faq = lazy(() => import("@/pages/Faq"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const AdminApp = lazy(() => import("@/pages/admin/AdminApp"));
const AuthCallback = lazy(() => import("@/pages/AuthCallback"));

const withLayout = (node) => (
  <PublicLayout>
    <Suspense fallback={<Loading />}>{node}</Suspense>
  </PublicLayout>
);

function AppRoutes() {
  // Kesan session_id semasa render (bukan dalam useEffect) supaya tiada race condition.
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return withLayout(<AuthCallback />);
  }

  return (
    <>
      <Routes>
        <Route path="/" element={withLayout(<Landing />)} />
        <Route path="/hantar-soalan" element={withLayout(<SubmitQuestion />)} />
        <Route path="/status/:token" element={withLayout(<StatusPage />)} />
        <Route path="/soalan-rakyat" element={withLayout(<Gallery />)} />
        <Route path="/cara-pemilihan" element={withLayout(<Methodology />)} />
        <Route path="/keputusan" element={withLayout(<Results />)} />
        <Route path="/tonton" element={withLayout(<Watch />)} />
        <Route path="/privasi" element={withLayout(<Privacy />)} />
        <Route path="/terma" element={withLayout(<Terms />)} />
        <Route path="/faq" element={withLayout(<Faq />)} />
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<Loading />}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route path="*" element={withLayout(<NotFound />)} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
